import { AgChartInstance, AgChartOptions } from "ag-charts-community";
import { AgCharts } from "ag-charts-react";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from "react";

const AnalyticsChart = forwardRef<AgChartInstance<AgChartOptions>, { options: AgChartOptions }>(
  ({ options }, ref) => {
    const chartInstanceRef = useRef<AgChartInstance<AgChartOptions> | null>(null);

    const handleChartRef = useCallback((instance: AgChartInstance<AgChartOptions> | null) => {
      if (instance) {
        chartInstanceRef.current = instance;
      }
    }, []);

    useImperativeHandle(ref, () => chartInstanceRef.current as AgChartInstance<AgChartOptions>);

    useEffect(
      () => () => {
        chartInstanceRef.current?.destroy?.();
        chartInstanceRef.current = null;
      },
      [],
    );

    return (
      <div className="h-full w-full">
        <AgCharts ref={handleChartRef} options={options} className="h-full w-full" />
      </div>
    );
  },
);

AnalyticsChart.displayName = "AnalyticsChart";

export default AnalyticsChart;
